import { render, staticRenderFns } from "./data-disposal-period-form.vue?vue&type=template&id=280743e0"
import script from "./data-disposal-period-form.vue?vue&type=script&lang=js"
export * from "./data-disposal-period-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports